import { createContext, useMemo, useState } from 'react';
type UserContextType = {
  user: any;
  setUser: React.Dispatch<React.SetStateAction<any>>;
};
const userState = {
  user: null,
  setUser: () => null
};
export const UserDetailsContext = createContext<UserContextType>(userState);
const UserDetailsContextProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [user, setUser] = useState<any>();
  const userStore = useMemo(() => {
    return {
      user,
      setUser
    };
  }, [user, setUser]);
  return <UserDetailsContext.Provider value={userStore} data-sentry-element="unknown" data-sentry-component="UserDetailsContextProvider" data-sentry-source-file="UserDetailsContextProvider.tsx">{children}</UserDetailsContext.Provider>;
};
export default UserDetailsContextProvider;